import React, {useState} from 'react';
import {FloorPlan, FloorPlanOption} from "../SharedTypes";
import {makeStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Clear from "@material-ui/icons/Clear";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Typography from "@material-ui/core/Typography";
import Add from "@material-ui/icons/Add";
import {FloorPlanOptionEditor} from "./FloorPlanOptionEditor";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import OptionValueTable from "./OptionValueTable";

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650,
    },
    container: {
        margin: 'auto',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        maxWidth: theme.breakpoints.values.md,
    },
    containerForm: {
        margin: 'auto',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        maxWidth: theme.breakpoints.values.md,
        padding: theme.spacing(2)
    },
    infoColor: {
        color: theme.palette.info.dark
    },
    dangerColor: {
        color: theme.palette.error.dark
    },
}));

function FloorPlanOptionTable({
                                  floorPlan, onChange, onSave, onBack
                              }: {
    floorPlan: FloorPlan, onChange: (newFloorPlan: FloorPlan) => any,
    onSave: (newFloorPlan: FloorPlan) => any, onBack: () => any
}) {
    const classes = useStyles(),
        options = floorPlan.options || [],
        [editOption, setEditOption] = useState<{ option: FloorPlanOption, index?: number } | undefined>(),
        [editOptionValues, setEditOptionValues] = useState<{ option: FloorPlanOption, index?: number } | undefined>();

    return (
        editOptionValues
            ? <OptionValueTable floorPlanOption={editOptionValues.option}
                                onChange={option => setEditOptionValues({option, index: editOptionValues.index})}
                                onSave={newOption => {
                                    const newFloorPlan = {
                                        ...floorPlan, options: options.map((o, i) =>
                                            i === editOptionValues.index ? newOption : o)
                                    };
                                    onChange(newFloorPlan);
                                    onSave(newFloorPlan);
                                }} onBack={() => setEditOptionValues(undefined)}/>
            : (editOption !== undefined) ? <Paper className={classes.containerForm}>
                <FloorPlanOptionEditor option={editOption.option}
                                       onChange={option => setEditOption({option, index: editOption.index})}
                                       onSave={() => {
                                           let newFloorPlan;
                                           if (editOption.index !== undefined) {
                                               const newOptions = [...options];
                                               newOptions.splice(editOption.index, 1, editOption.option);
                                               newFloorPlan = {...floorPlan, options: newOptions};
                                           } else {
                                               newFloorPlan = {
                                                   ...floorPlan,
                                                   options: options.concat([editOption.option])
                                               };
                                           }
                                           onChange(newFloorPlan);
                                           onSave(newFloorPlan);
                                           setEditOption(undefined);
                                       }}
                                       onBack={() => {
                                           setEditOption(undefined)
                                       }}/>
            </Paper>
            : <TableContainer component={Paper} className={classes.container}>
                <Typography component="h2" variant="h4" style={{margin: '1rem'}}>Options
                    for {floorPlan.name}</Typography>
                <div style={{padding: '1rem'}}>
                    <Button size="small" color="primary" onClick={onBack} startIcon={<ChevronLeft/>}>Back</Button>
                </div>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell/>
                            <TableCell component="th">Name</TableCell>
                            <TableCell component="th" align="right"/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {options.map((opt, index) => <TableRow key={opt.name}>
                            <TableCell>
                                <Avatar src={opt.photo?.url}/>
                            </TableCell>
                            <TableCell>
                                {opt.name}
                            </TableCell>
                            <TableCell align="right">

                                <Button size="small" color="primary" style={{marginRight: '1rem'}}
                                        onClick={() => setEditOptionValues({option: opt, index})}>
                                    Edit Values
                                </Button>
                                <Tooltip title="Edit Option">
                                    <IconButton onClick={() =>
                                        setEditOption({index, option: opt})}>
                                        <Edit className={classes.infoColor}/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Remove Option">
                                    <IconButton onClick={async () => {
                                        const newOptions = [...options];
                                        newOptions.splice(index, 1);
                                        const newFloorPlan = {...floorPlan, options: newOptions};
                                        onChange(newFloorPlan);
                                        onSave(newFloorPlan);
                                    }}>
                                        <Clear className={classes.dangerColor}/>
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
                <Button color="primary" startIcon={<Add/>}
                        onClick={() => {
                            setEditOption({
                                option: {
                                    name: '',
                                    description: '',
                                    photo: {id: 0, url: ''},
                                    values: [],
                                }
                            });
                        }}>
                    Add Option
                </Button>
            </TableContainer>
    );
}

export default FloorPlanOptionTable;